import React from 'react';
import SelectUser from './SelectUser';
import CustomSelect from './CustomSelect';
import TextFieldCustom from './TextFieldCustom';
import { GridColDef } from '@mui/x-data-grid';
import { FieldErrors } from '../domain/helpers/Errors';

interface RowItemProps<T extends { [key: string]: any }> {
    form: T;
    view: boolean;
    column: GridColDef;
    errors: FieldErrors;
    setForm: React.Dispatch<React.SetStateAction<T>>;
}

export const RowItem = <T extends { [key: string]: any }>({ column, form, errors, view = false, setForm }: RowItemProps<T>) => {

    const containsId = column.field.endsWith('Id') && column.field !== 'taxId';
    const label = containsId ? column.headerName?.slice(0, -2) : column.headerName;
    const isUser = column.field === 'user';

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, isDate?: boolean) => {
        const { id, value, type } = e.target;

        if (isDate) setForm({ ...form, [id]: value });
        else setForm({ ...form, [id]: type === 'number' ? parseInt(value) : value });

        delete errors?.[id];
    };

    return isUser
        ? <SelectUser
            form={form}
            view={view}
            errors={errors}
            column={column}
            setForm={setForm}
        />
        : containsId
            ? <CustomSelect
                form={form}
                view={view}
                label={label}
                errors={errors}
                column={column}
                setForm={setForm}
            />
            : <TextFieldCustom
                form={form}
                view={view}
                column={column}
                errors={errors}
                setForm={setForm}
                handleChange={handleChange}
            />
}
export default RowItem;